<template>
    <div class="thumbnail__tags" v-if="showTags">
        <TotemRibbon :ribbon="mapCourseToRibbon(course)" />
        <TotemRibbon :ribbon="mapCourseToTimeBasedRibbon(course)" v-if="!isCompletedItem" />
        <TotemRibbon :ribbon="{ name: $t('Ribbon.live'), color: 'live'}" v-if="isLive(course)" />
        <TotemRibbon :ribbon="{ name: $t('Ribbon.free'), color: 'free'}" v-if="isFree" />
        <TotemRibbon :ribbon="{ name: $t('Ribbon.promotional'), color: 'promotional'}" v-if="isPromotional" />
        <TotemCompletedTag :course="course" v-if="isCompleted" />
        <TotemAuthorizationId :id="course.authorizationId" v-if="showAuthorizationId(course)" />
        <TotemSignUpTag :course="course" v-if="showSignUpToDigitalClassRoomInfo" />
        <TotemLastWatchedTag :course="course" v-if="isUncompletedItem"/>
    </div>
</template>

<script>
    import ThumbnailTagsHelper from 'components/shared/global-courses-items/helper/thumbnail-tags-helper'
    export default {
        name: 'thumbnail-tags',
        mixins: [ ThumbnailTagsHelper ]
    }
</script>

<style lang="scss">
    .thumbnail {
        &__tags {
            font-family: Nunito-Regular, sans-serif;
            font-size: 1.3rem;
            display: flex;
            flex-wrap: wrap;
            padding: 10px 0 0 0;
        }
    }
</style>
